import axios from '@/libs/api.request'

export const AddPayee = (data) => {
  return axios.request({
    url: '/print/payment/user/AddPayee',
    data,
    method: 'post'
  })
}
export const GetPayee = data => {
  return axios.request({
    url: '/print/payment/user/GetPayee',
    params: data,
    method: 'get'
  })
}

export const GetUserAgentDispense = data => {
  return axios.request({
    url: 'print/payment/dispense',
    params: data,
    method: 'get'
  })
}
export const SaveUserAgentDispense = data => {
  return axios.request({
    url: 'print/payment/dispense',
    data,
    method: 'post'
  })
}

export const GetBalance = data => {
  return axios.request({
    url: 'print/payment/user/GetBalance',
    params: data,
    method: 'get'
  })
}

export const InitUserPWD = data => {
  return axios.request({
    url: 'print/payment/user/InitPWD',
    data,
    method: 'post'
  })
}
export const BatchDispense = data => {
  return axios.request({
    url: 'print/payment/BatchDispense',
    data,
    method: 'post'
  })
}

export const GetDispenseDetailed = data => {
  return axios.request({
    url: 'print/payment/GetDispenseDetailed',
    params: data,
    method: 'get'
  })
}
export const GetAngleDispenseDetailed = data => {
  return axios.request({
    url: 'print/payment/GetAngleDispenseDetailed',
    params: data,
    method: 'get'
  })
}
export const GetDispenseTotal = data => {
  return axios.request({
    url: 'print/payment/GetDispenseTotal',
    params: data,
    method: 'get'
  })
}
export const GetDispenseRefund = data => {
  return axios.request({
    url: 'print/payment/GetDispenseRefund',
    params: data,
    method: 'get'
  })
}
export const GetDispenseRefundMoney = data => {
  return axios.request({
    url: 'print/payment/GetDispenseRefundMoney',
    params: data,
    method: 'get'
  })
}
export const LogoutAccount = data => {
  return axios.request({
    url: 'print/payment/user/LogoutAccount',
    data,
    method: 'post'
  })
}
export const Withdrawal = data => {
  return axios.request({
    url: 'print/payment/user/withdrawal',
    data,
    method: 'post'
  })
}
